import { Response } from "express";

import { IResultHandler } from "./IResultHandler";

export class EmptyResultHandler implements IResultHandler {
    public async processResult(_result: unknown, _req: Express.Request, res: Response): Promise<void> {
        res.end();
    }
}
